import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import FormTextField from "components/form/FormTextField";
import { CorporateApp } from "../corporateAppModel";
import { WrappedFormSingleSelectField } from "components/form/FormSingleSelectField";
import { SelectOption } from "components/dropdown/Dropdown";
import { RadioButtons } from "components/form/radiobuttons/radiobuttons";
import { ErrorM } from "components/helpers/ErrorM";
interface Props {
  availableCountries: SelectOption[];
  availableStates: SelectOption[];
  expandAll: boolean;
}

const OperatingAddress: React.FC<Props> = ({
  availableCountries,
  availableStates,
  expandAll,
}) => {
  const [expand, setExpand] = useState<boolean>(false);
  const [completedSection, setCompletedSection] = useState(false);
  const { errors, values, touched, setFieldValue } = useFormikContext<
    CorporateApp
  >();

  const validateSection = () => {
    if (
      !errors.corporate?.operatingAddress &&
      touched.corporate?.operatingAddress
    ) {
      setCompletedSection(true);
    } else {
      setCompletedSection(false);
    }
  };
  useEffect(() => {
    if (expandAll) {
      setExpand(true);
    }
  }, [expandAll]);

  useEffect(() => {
    validateSection();
    if (errors.corporate?.operatingAddress) {
      setExpand(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors.corporate?.operatingAddress, touched.corporate?.operatingAddress]);

  useEffect(() => {
    if (
      values.corporate.operatingAddress.country === "USA" &&
      values.corporate.operatingAddress.stateProvince &&
      !availableStates.some(
        state => state.value === values.corporate.operatingAddress.stateProvince
      )
    ) {
      setFieldValue("corporate.operatingAddress.stateProvince", null);
    }
  }, [
    values.corporate.operatingAddress.stateProvince,
    values.corporate.operatingAddress.country,
    availableStates,
    setFieldValue,
  ]);

  return (
    <div>
      <ErrorM name="corporate.operatingAddress" />
      <div className="FormBox">
        <RadioButtons
          options={["Yes", "No"]}
          label={
            "Is the company operating address different from the registered address?"
          }
          fieldname={"corporate.operatingAddress.bUseDifferentAddress"}
          error={true}
          booleanField={true}
        />
      </div>
      {values.corporate.operatingAddress.bUseDifferentAddress && (
        <div className="FormBox">
          <FormTextField
            field={"corporate.operatingAddress.addressLine1"}
            label={"Street Name"}
            required={
              values.corporate.operatingAddress.bUseDifferentAddress === true
            }
            maxLength={200}
            asterisk={true}
          />
          <div className="FormSideBySide">
            <FormTextField
              field={"corporate.operatingAddress.postcode"}
              label={"ZIP / Postal code"}
              required={
                values.corporate.operatingAddress.bUseDifferentAddress === true
              }
              maxLength={200}
              sideBySide={true}
              asterisk={true}
            />
            {values.corporate.operatingAddress.country === "USA" ? (
              <div className="FormBuilderComponent SideBySide">
                <WrappedFormSingleSelectField
                  fieldName="corporate.operatingAddress.stateProvince"
                  label={"State / Province*"}
                  options={availableStates}
                />
              </div>
            ) : (
              <FormTextField
                field="corporate.operatingAddress.stateProvince"
                label={"State / Province"}
                required={
                  values.corporate.operatingAddress.bUseDifferentAddress ===
                  true
                }
                maxLength={200}
                sideBySide={true}
                asterisk={true}
              />
            )}
          </div>
          <div className="FormSideBySide">
            <FormTextField
              field={"corporate.operatingAddress.city"}
              label={"City"}
              required={
                values.corporate.operatingAddress.bUseDifferentAddress === true
              }
              maxLength={200}
              sideBySide={true}
              asterisk={true}
            />
            <div className="FormBuilderComponent SideBySide">
              <WrappedFormSingleSelectField
                fieldName={"corporate.operatingAddress.country"}
                options={availableCountries}
                label="Country*"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OperatingAddress;
